import { useTu } from "@src/appV2/i18n/useTu";

import { Select, type SelectOption } from "../../components/Select";
import { LabeledField } from "./LabeledField";

interface RoleSelectFieldProps {
  options: SelectOption[];
  value: string | undefined;
  onChange: (qualification: string) => void;
}

/**
 * "Role" qualification dropdown for the Add Shift panel.
 */
export function RoleSelectField(props: RoleSelectFieldProps) {
  const { tu } = useTu("schedule");
  const { options, value, onChange } = props;

  return (
    <LabeledField label={tu("Role")}>
      <Select
        fullWidth
        size="small"
        options={options}
        value={value ?? ""}
        placeholder={tu("Select a role")}
        inputProps={{ "aria-label": tu("Role") }}
        onChange={onChange}
      />
    </LabeledField>
  );
}
